/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RadarStrategyVersionOptionResponse = {
    strategy_version_id: string;
    strategy_id: string;
    account_id: string;
    status: RadarStrategyVersionOptionResponse.status;
    portfolio_id: string;
    portfolio_name: string;
};
export namespace RadarStrategyVersionOptionResponse {
    export enum status {
        PUBLISHED = 'published',
        DEPRECATED = 'deprecated',
    }
}

